import { useQuery } from '@tanstack/react-query';
import { CalendarResponse } from '../../../../types/Calendar';
import CustomAxios from '../../../../utility/customAxios';
import { queryKeys } from '../../queryKeys';

export type UseGetGoogleCalendarsProps = {
  enabled?: boolean;
};

export const fetchGoogleCalendars = async () => {
  const response = await CustomAxios.get<CalendarResponse>(`integrations/google/calendars`);
  const { data } = response;
  return data;
};

export function useGetGoogleCalendars({ enabled = true }: UseGetGoogleCalendarsProps) {
  const queryKey: any = [queryKeys.googleCalendars];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: fetchGoogleCalendars,
  });
  return query;
}
